import React from 'react'

type Props = React.SVGAttributes<SVGSVGElement>

export const PlayStore: React.FC<Props> = props => {
  return (
    <svg width={136} height={40} viewBox="0 0 136 40" fill="none" {...props}>
      <g clipPath="url(#playstore_svg__clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M130.966 40H5.039C2.262 40 0 37.746 0 35V5c0-2.756 2.262-5 5.04-5h125.926c2.775 0 5.039 2.244 5.039 5v30c0 2.746-2.264 5-5.039 5z"
          fill="#000"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M130.961.8c2.329 0 4.236 1.888 4.236 4.2v30c0 2.312-1.894 4.2-4.236 4.2H5.039C2.709 39.2.803 37.312.803 35V5C.803 2.688 2.697.8 5.04.8H130.96zm0-.8H5.039C2.262 0 0 2.254 0 5v30c0 2.756 2.262 5 5.039 5H130.96c2.775 0 5.039-2.244 5.039-5V5c0-2.746-2.264-5-5.039-5z"
          fill="#A6A6A6"
        />
        <path
          d="M71.646 13.232c-.908 0-1.674-.317-2.28-.94a3.196 3.196 0 01-.92-2.295c0-.91.31-1.68.92-2.292.604-.623 1.37-.94 2.278-.94.898 0 1.663.317 2.279.94.61.631.92 1.402.92 2.292-.01.913-.32 1.683-.92 2.292-.603.628-1.369.943-2.277.943zm-27.023 0a3.172 3.172 0 01-2.29-.928c-.625-.614-.943-1.39-.943-2.304 0-.916.318-1.691.944-2.305.617-.616 1.388-.927 2.289-.927.44 0 .868.087 1.278.264.403.172.73.407.973.693l.06.073-.677.663-.07-.082c-.383-.454-.896-.676-1.574-.676-.606 0-1.134.214-1.569.638-.438.427-.66.985-.66 1.661s.222 1.234.66 1.661a2.18 2.18 0 001.569.638c.645 0 1.188-.214 1.611-.638.25-.25.405-.599.46-1.04H44.51V9.69h3.108l.012.085c.023.157.045.32.045.469 0 .86-.26 1.556-.775 2.07-.586.608-1.352.918-2.277.918zm35.93-.133h-.958L76.66 8.42l.025.842v3.836h-.958V6.9h1.093l.03.047 2.76 4.41-.025-.841V6.9h.968v6.2zm-16.107 0h-.971V7.833H61.79V6.9h4.336v.933h-1.684v5.266h.003zM61 13.1h-.968V6.9H61v6.2zm-5.441 0h-.969V7.833h-1.683V6.9h4.336v.933h-1.684v5.266zm-3.265-.01H48.58V6.9h3.713v.934h-2.742v1.7h2.474v.923h-2.474v1.7h2.742v.933zm17.783-1.439c.433.432.959.649 1.57.649.627 0 1.14-.212 1.568-.649.425-.424.64-.98.64-1.65 0-.671-.215-1.23-.638-1.651A2.15 2.15 0 0071.65 7.7c-.628 0-1.141.212-1.567.649-.425.424-.64.98-.64 1.65 0 .671.213 1.23.635 1.651z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68.353 21.756c-2.365 0-4.281 1.788-4.281 4.254 0 2.444 1.929 4.254 4.28 4.254 2.365 0 4.281-1.8 4.281-4.254 0-2.466-1.916-4.254-4.28-4.254zm0 6.823c-1.294 0-2.407-1.068-2.407-2.579 0-1.534 1.115-2.578 2.407-2.578 1.293 0 2.406 1.044 2.406 2.578.003 1.521-1.113 2.579-2.406 2.579zm-9.34-6.823c-2.365 0-4.281 1.788-4.281 4.254 0 2.444 1.929 4.254 4.28 4.254 2.365 0 4.281-1.8 4.281-4.254 0-2.466-1.919-4.254-4.28-4.254zm0 6.823c-1.294 0-2.407-1.068-2.407-2.579 0-1.534 1.115-2.578 2.407-2.578 1.293 0 2.406 1.044 2.406 2.578 0 1.521-1.113 2.579-2.406 2.579zm-11.114-5.524v1.8h4.336c-.133 1.01-.468 1.756-.981 2.267-.636.634-1.616 1.322-3.345 1.322-2.665 0-4.75-2.145-4.75-4.8 0-2.656 2.085-4.801 4.75-4.801 1.438 0 2.487.566 3.265 1.29l1.28-1.278c-1.08-1.032-2.519-1.823-4.535-1.823-3.656 0-6.723 2.968-6.723 6.602 0 3.643 3.065 6.6 6.723 6.6 1.974 0 3.455-.643 4.626-1.855 1.193-1.19 1.571-2.868 1.571-4.222 0-.421-.032-.8-.1-1.122h-6.12c.003-.003.003.02.003.02zm45.459 1.401c-.358-.955-1.44-2.71-3.656-2.71-2.197 0-4.023 1.723-4.023 4.254 0 2.39 1.806 4.254 4.236 4.254 1.951 0 3.087-1.19 3.555-1.887l-1.449-.968c-.48.71-1.148 1.177-2.096 1.177-.959 0-1.63-.434-2.074-1.29l5.707-2.356c0 .003-.2-.474-.2-.474zm-5.82 1.422c-.045-1.643 1.28-2.479 2.23-2.479.747 0 1.37.367 1.583.9l-3.813 1.579zM82.902 30h1.874V17.501h-1.874v12.5zm-3.078-7.3h-.067c-.423-.5-1.226-.954-2.252-.954-2.13 0-4.091 1.867-4.091 4.267 0 2.388 1.952 4.234 4.09 4.234 1.014 0 1.83-.456 2.253-.968h.067v.611c0 1.624-.87 2.5-2.274 2.5-1.149 0-1.862-.824-2.152-1.512l-1.629.678c.468 1.122 1.717 2.511 3.778 2.511 2.197 0 4.059-1.289 4.059-4.433V22h-1.772v.7h-.01zm-2.152 5.879c-1.293 0-2.374-1.078-2.374-2.567 0-1.5 1.08-2.588 2.374-2.588 1.281 0 2.275 1.1 2.275 2.588.012 1.49-.991 2.567-2.275 2.567zm24.46-11.078h-4.481v12.5h1.874v-4.734h2.609c2.075 0 4.114-1.499 4.114-3.878s-2.032-3.888-4.116-3.888zm.055 6.02h-2.665v-4.289h2.665c1.404 0 2.197 1.155 2.197 2.145 0 .98-.803 2.144-2.197 2.144zm11.572-1.788c-1.361 0-2.765.601-3.345 1.91l1.661.689c.358-.689 1.013-.923 1.706-.923.971 0 1.952.579 1.974 1.611v.132c-.335-.19-1.07-.479-1.951-.479-1.794 0-3.613.978-3.613 2.81 0 1.68 1.471 2.756 3.11 2.756 1.258 0 1.951-.566 2.384-1.222h.068v.968h1.806v-4.788c0-2.23-1.661-3.464-3.8-3.464zm-.235 6.846c-.613 0-1.472-.3-1.472-1.068 0-.967 1.071-1.334 1.985-1.334.825 0 1.215.177 1.706.422a2.253 2.253 0 01-2.219 1.98zM124.15 22l-2.152 5.422h-.068L119.701 22h-2.017l3.346 7.579-1.907 4.212h1.952L126.221 22h-2.071zm-16.869 8h1.874V17.501h-1.874v12.5z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.466 7.533c-.29.312-.457.788-.457 1.412v22.112c0 .623.167 1.1.467 1.399l.078.067 12.43-12.389v-.277L10.543 7.466l-.078.067z"
          fill="url(#playstore_svg__paint0_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.122 24.276l-4.145-4.132v-.29l4.145-4.131.09.055 4.905 2.778c1.403.788 1.403 2.09 0 2.887l-4.904 2.778-.09.055z"
          fill="url(#playstore_svg__paint1_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.211 24.222L22.976 20 10.469 32.466c.457.49 1.226.544 2.084.068l14.658-8.312z"
          fill="url(#playstore_svg__paint2_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.211 15.777L12.553 7.479c-.859-.489-1.63-.421-2.085.068L22.977 20l4.235-4.223z"
          fill="url(#playstore_svg__paint3_linear)"
        />
        <path
          opacity={0.2}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.122 24.132l-14.56 8.245c-.813.467-1.538.434-2.006.01l-.078.078.078.067c.468.421 1.193.456 2.006-.01l14.66-8.3-.1-.09z"
          fill="#000"
        />
        <path
          opacity={0.12}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.114 21.3l-5.006 2.832.09.09 4.904-2.778c.703-.4 1.048-.923 1.048-1.444-.042.479-.4.933-1.036 1.3z"
          fill="#000"
        />
        <path
          opacity={0.25}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.55 7.624L32.113 18.7c.636.357.993.823 1.048 1.3 0-.522-.345-1.046-1.048-1.445L12.55 7.48c-1.403-.8-2.542-.132-2.542 1.466v.145c0-1.601 1.139-2.257 2.542-1.466z"
          fill="#fff"
        />
      </g>
      <defs>
        <linearGradient
          id="playstore_svg__paint0_linear"
          x1={21.869}
          y1={8.706}
          x2={1.967}
          y2={14.026}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset={0.007} stopColor="#00A1FF" />
          <stop offset={0.26} stopColor="#00BEFF" />
          <stop offset={0.512} stopColor="#00D2FF" />
          <stop offset={0.76} stopColor="#00DFFF" />
          <stop offset={1} stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="playstore_svg__paint1_linear"
          x1={33.947}
          y1={20}
          x2={9.67}
          y2={20}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset={0.409} stopColor="#FFBD00" />
          <stop offset={0.775} stopColor="orange" />
          <stop offset={1} stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="playstore_svg__paint2_linear"
          x1={24.908}
          y1={22.297}
          x2={9.002}
          y2={49.157}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset={1} stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="playstore_svg__paint3_linear"
          x1={7.319}
          y1={0.178}
          x2={14.416}
          y2={12.174}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset={0.069} stopColor="#2DA771" />
          <stop offset={0.476} stopColor="#15CF74" />
          <stop offset={0.801} stopColor="#06E775" />
          <stop offset={1} stopColor="#00F076" />
        </linearGradient>
        <clipPath id="playstore_svg__clip0">
          <path fill="#fff" d="M0 0h136v40H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
